import React from "react";
import errorimg from "../../../../images/error.png";
import { Modal, ModalBody } from "reactstrap";
import close from "../../../../images/close.svg";
import "../../Kiosk.css";
import { IkioskManager, IKioskModel } from "models/kioskModel";
import { useSelector, useDispatch } from "react-redux";
import { suspendErrorMethod } from "../../../../store/actions";
import { getShowMessageTime } from "../../../../helpers/helpersIndex";
import { useTranslation } from "react-i18next";

let setinterval;

const ThemeOneErrorBlock: React.FC = () => {
  const { t } = useTranslation("translations");
  const errorMessage = useSelector((state: any) => {
    if (state?.kioskReducer?.errorMessage)
      return (state.kioskReducer as IKioskModel).errorMessage;
    else return undefined;
  });
  const dispatch = useDispatch();
  const selectedArea = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel)?.selectedArea
  );
  console.log("ThemeOneErrorBlock =>", selectedArea, errorMessage);

  const suspendErrorInitiate = () => {
    const redirectingMenus =
      errorMessage &&
      [IkioskManager.EMIRADESVERIFICATION,IkioskManager.MRNVERIFICATION,IkioskManager.LOADAPPOINTMENTS].includes(selectedArea) ? IkioskManager.EMIRADESVERIFICATION : IkioskManager.HOME;
    dispatch(suspendErrorMethod(redirectingMenus));
    if (setinterval) clearTimeout(setinterval);
  };

  if (errorMessage) {
    setinterval = setTimeout(() => {
      suspendErrorInitiate();
    }, getShowMessageTime() * 1000);
  }
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });

  return (
    <>
      {errorMessage && errorMessage !== "" && (
        <Modal isOpen={errorMessage !== "" ? true : false}>
          <ModalBody>
            <div className="error_container">
              <div className="errorMessage">
                <div className="close-button" onClick={suspendErrorInitiate}>
                  <img src={close} alt="" width="30" />
                </div>
                <img src={errorimg} alt="" width="400" />
                {errorMessage === "EM0" && (
                  <p>{t("errorMessage.EM7" + language)}</p>
                )}
                {errorMessage !== "EM0" && (
                  <p>
                    {t("errorMessage." + errorMessage + language) ===
                    "errorMessage." + errorMessage + language
                      ? errorMessage
                      : t("errorMessage." + errorMessage + language)}
                  </p>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
export default React.memo(ThemeOneErrorBlock);
